import Routing from "./routes/Routing";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

function App() {
  return ( 
    <Routing/>
  );
}

export default App;
